import React, { useState } from "react";
import { api, formatError } from "../lib/api";
import { Button } from "./ui/button";
import VerifiedBadge from "./VerifiedBadge";
import { toast } from "sonner";

export default function VerificationCard({ profile, onDone }) {
  const [idDoc, setIdDoc] = useState(null);
  const [cert, setCert] = useState(null);
  const [busy, setBusy] = useState(false);
  if (!profile) return null;
  const v = profile.verification;

  const submit = async () => {
    if (!idDoc || !cert) return toast.error("Please attach both documents");
    const fd = new FormData(); fd.append("id_doc", idDoc); fd.append("cert_doc", cert);
    setBusy(true);
    try { await api.post("/gurus/me/verification", fd); toast.success("Documents submitted for review"); onDone(); }
    catch (e) { toast.error(formatError(e)); } finally { setBusy(false); }
  };

  return (
    <section data-testid="verification-card" className="mt-10 bg-[#FFFDF9] sacred-border rounded-2xl p-6">
      <div className="flex items-center gap-2"><h2 className="font-serif text-2xl text-[#4A0E17]">Verified teacher badge</h2><VerifiedBadge show={profile.verified} label /></div>
      {profile.verified ? (
        <p className="text-sm text-[#63534E] mt-2">Your blue tick shows on your profile and on teacher cards.</p>
      ) : v?.status === "pending" ? (
        <p data-testid="verification-pending" className="text-sm text-amber-800 mt-2">Your documents are being reviewed. This usually takes up to 48 hours.</p>
      ) : (
        <>
          <p className="text-sm text-[#63534E] mt-2">Upload a government ID and your Vedic / professional certificate to earn the blue verified tick.{v?.status === "rejected" && <span className="text-red-700"> Previous submission was rejected{v.note ? `: ${v.note}` : ""}.</span>}</p>
          <div className="mt-4 grid sm:grid-cols-2 gap-3">
            <label className="text-sm text-[#4A0E17]">Government ID<input data-testid="verify-id-input" type="file" accept="image/*,application/pdf" onChange={(e) => setIdDoc(e.target.files?.[0])} className="block mt-1 text-xs" /></label>
            <label className="text-sm text-[#4A0E17]">Vedic certificate<input data-testid="verify-cert-input" type="file" accept="image/*,application/pdf" onChange={(e) => setCert(e.target.files?.[0])} className="block mt-1 text-xs" /></label>
          </div>
          <Button data-testid="verify-submit" disabled={busy} onClick={submit} className="mt-4 bg-[#1D6FE0] hover:bg-[#1558B5] rounded-full h-10 px-6">{busy ? "Uploading…" : "Submit for verification"}</Button>
        </>
      )}
    </section>
  );
}
